import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-participantessorteopt',
  templateUrl: './participantessorteopt.component.html',
  styleUrls: ['./participantessorteopt.component.scss']
})
export class ParticipantessorteoptComponent implements OnInit {

  dataNuevos: any[] = [];
  filteredData: any[] = [];
  searchText: string = '';
  p: number = 1;

  constructor() {
    this.loadExcel();
  }

  ngOnInit(): void { }

  loadExcel() {
    const url = 'assets/pdf/ganadores_sorteo_magno.xlsx';
    fetch(url)
      .then(response => response.arrayBuffer())
      .then(buffer => {
        const workbook = XLSX.read(buffer, { type: 'array' });

        const sheetNuevos = workbook.Sheets['ganadores'];

        this.dataNuevos = XLSX.utils.sheet_to_json(sheetNuevos);

        // Inicializa el filtro con los datos de Nuevos
        this.filteredData = this.dataNuevos;
      })
      .catch(error => console.error('Error loading Excel file:', error));
  }



  filterData() {
    const term = this.searchText.trim().toLowerCase();

    this.filteredData = this.dataNuevos.filter(participante => {
      // 1. Obtener y limpiar los datos de los participantes (existente)
      const lugar = participante.lugar ? participante.lugar.toString().toLowerCase() : '';
      const nombre_comprador = participante.nombre_comprador ? participante.nombre_comprador.toString().toLowerCase() : '';
      const apellidos_comprador = participante.apellidos_comprador ? participante.apellidos_comprador.toString().toLowerCase() : '';
      const folio = participante.folio ? participante.folio.toString().toLowerCase() : '';

      // 2. CÓDIGO AÑADIDO: Generar las iniciales para la búsqueda 
      const apellidos_iniciales = this.getInitials(participante.apellidos_comprador).toLowerCase();

       const nombre_col = participante.nombre_col ? participante.nombre_col.toString().toLowerCase() : '';

      // 3. Filtrar si el término de búsqueda está en cualquiera de los campos
      return (
        folio.includes(term) ||               // Búsqueda por Folio
        nombre_comprador.includes(term) ||    // Búsqueda por Nombre
        apellidos_comprador.includes(term) || // Búsqueda por Apellidos
        apellidos_iniciales.includes(term)  ||
        nombre_col.includes(term)   // Búsqueda por Iniciales (ej. "h. c.") 
      );
    });
  }

  // Nota: La función getInitials debe estar definida en el mismo objeto (this)
  // o accesible globalmente. Asumiendo que está en el mismo objeto:
  getInitials(fullName) {
    if (!fullName) {
      return '';
    }
    const nameString = fullName.toString().trim();
    const initials = nameString
      .split(/\s+/)
      .map(word => word.charAt(0).toUpperCase())
      .join('. ');
    return initials + '.';
  }

}
